import { render, staticRenderFns } from "./FormSkipButton.vue?vue&type=template&id=45a326e3&scoped=true&"
import script from "./FormSkipButton.vue?vue&type=script&lang=ts&"
export * from "./FormSkipButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a326e3",
  null
  
)

export default component.exports